import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classes from "./ResourceImagePlaceHolder.scss";
import { getRethumbUrl } from "Utils";
import {
  PLACEHOLDER_RECT_IMAGE,
  PLACEHOLDER_RECT_IMAGE_COUNT,
} from "Constants";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";

const getRethumb = ({ imageUrl, imageThumbSize }) => {
  const rethumpUrl = imageUrl
    ? getRethumbUrl({
        width: imageThumbSize,
        height: imageThumbSize,
        imageUrl: imageUrl,
        fitIn: true,
      })
    : "";
  return `url(${rethumpUrl})`;
};

const ResourceImagePlaceHolder = ({
  type,
  imageUrl,
  imageThumbSize,
  icon,
  id,
  containerStyle = {},
  getCurrentAssessmentTypes,
}) => {
  const currentAssessmentTypes = getCurrentAssessmentTypes();
  //const typeVal = _.get(type, "value", "le");
  const typeVal = "le";
  const typeText = _.get(currentAssessmentTypes[typeVal], "abbrevation", "");

  const rethumpUrl = !typeText
    ? getRethumb({
        imageUrl:
          imageUrl || PLACEHOLDER_RECT_IMAGE[id % PLACEHOLDER_RECT_IMAGE_COUNT],
        imageThumbSize,
      })
    : "";

  return !typeText && !icon ? (
    <div
      className={classes.imageContainer}
      style={{
        backgroundImage: rethumpUrl,
        ...containerStyle,
      }}
    />
  ) : (
    <div className={classes.container} style={containerStyle}>
      {icon ? icon : <div className={classes.text}>{typeText}</div>}
    </div>
  );
};

const mapActionCreators = { getCurrentAssessmentTypes };

export default connect(null, mapActionCreators)(ResourceImagePlaceHolder);

ResourceImagePlaceHolder.propTypes = {
  imageUrl: PropTypes.string,
  imageThumbSize: PropTypes.number,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

ResourceImagePlaceHolder.defaultProps = {
  type: "",
  imageUrl: "",
  imageThumbSize: 128,
};
